import { useBreakpoint } from 'app/spacing';
import { useTranslation } from 'react-i18next';
import {
  ComponentWrapper,
  PaginationWrapper,
  SearchPillWrapper,
  StyledModal,
  StyledTableScrollContainer,
  TableWrapper,
  Toolbar,
  StyledSwitch,
} from './styles';
import TablePagination from 'components/Tables/Big/TablePagination';
import { Gradient } from 'components/Kizen/ScrollFadeContainer';
import { TRow } from 'components/Kizen/Table';
import BasicTable from 'components/Tables/Basic';
import { SearchPill } from '@kizen/kds/SearchPill';
import { EMPTY_OBJECT } from 'utility/fieldHelpers';

export const HistoryModal = ({
  results,
  count,
  key,
  heading,
  columns,
  pagination = EMPTY_OBJECT,
  loading,
  showSearch,
  showEventTypeFilter,
  searchPlaceholder,
  setExcludeEventType,
  excludeEventType,
  ...rest
}) => {
  const { t } = useTranslation();
  const isMobile = useBreakpoint();
  const {
    page,
    pageSize,
    handleChangePage,
    handleChangePageSize,
    headData,
    handleChangeSearch,
    actualSearch,
  } = pagination;

  return isMobile ? null : (
    <StyledModal
      buttonText={t('Close')}
      actionBtnColor="blue"
      leftBtn={null}
      heading={heading}
      size="medium"
      {...rest}
      showSearch={showSearch}
      displayFlex
    >
      <ComponentWrapper>
        {showSearch ? (
          <Toolbar>
            {showEventTypeFilter ? (
              <StyledSwitch
                checked={!excludeEventType.length}
                label={t('Include Login events')}
                textPlacement="left"
                removeMargin={false}
                onChange={(event) => {
                  if (event.currentTarget.checked) {
                    setExcludeEventType([]);
                  } else {
                    setExcludeEventType(['login']);
                  }
                }}
              />
            ) : null}
            <SearchPillWrapper>
              <SearchPill
                boundaryClassName="modal-body"
                placeholder={searchPlaceholder ?? t('Search')}
                loading={loading}
                onChange={handleChangeSearch}
                value={actualSearch}
              />
            </SearchPillWrapper>
          </Toolbar>
        ) : null}
        <TableWrapper>
          <StyledTableScrollContainer
            isTable
            bottom
            refresh={loading}
            top
            gradient={<Gradient />}
          >
            <BasicTable
              key={key}
              stickyHeader
              head={<TRow head columns={columns} data={headData} />}
              data-qa="history-table"
              staleData={loading}
            >
              {count ? null : <TRow />}
              {results.map((data) => (
                <TRow key={data.id} columns={columns} data={data} />
              ))}
            </BasicTable>
          </StyledTableScrollContainer>
        </TableWrapper>
        <PaginationWrapper>
          <TablePagination
            page={page}
            perPage={pageSize}
            totalCount={count}
            onChangePage={handleChangePage}
            onChangePerPage={handleChangePageSize}
          />
        </PaginationWrapper>
      </ComponentWrapper>
    </StyledModal>
  );
};
